// @flow
const ADMIN_LOGIN = 'admin/auth/ADMIN_LOGIN';
const ADMIN_LOGIN_FAIL = 'admin/auth/ADMIN_LOGIN_FAIL';
const ADMIN_LOGIN_SUCCESS = 'admin/auth/ADMIN_LOGIN_SUCCESS';

const ADMIN_LOGOUT = 'admin/auth/ADMIN_LOGOUT';
const ADMIN_LOGOUT_FAIL = 'admin/auth/ADMIN_LOGOUT_FAIL';
const ADMIN_LOGOUT_SUCCESS = 'admin/auth/ADMIN_LOGOUT_SUCCESS';

const ADMIN_PROPERTIES_INTERVAL_RESOURCE = 'ADMIN_PROPERTIES_INTERVAL_RESOURCE';
const RESOURCE_ADMIN_PROPERTIES_INTERVAL =
  'admin/auth/RESOURCE_ADMIN_PROPERTIES_INTERVAL';

const CLEAR_IDENTITY_SESSION = 'admin/CLEAR_IDENTITY_SESSION';

const GET_PUBLIC_KEY = 'admin/GET_PUBLIC_KEY';
const GET_PUBLIC_KEY_SUCCESS = 'admin/GET_PUBLIC_KEY_SUCCESS';
const GET_PUBLIC_KEY_FAIL = 'admin/GET_PUBLIC_KEY_FAIL';

const IDENTITY_LOGIN = 'admin/auth/IDENTITY_LOGIN';
const IDENTITY_LOGIN_FAIL = 'admin/auth/IDENTITY_LOGIN_FAIL';
const IDENTITY_LOGIN_SUCCESS = 'admin/auth/IDENTITY_LOGIN_SUCCESS';

const IDENTITY_LOGOUT = 'admin/auth/IDENTITY_LOGOUT';
const IDENTITY_LOGOUT_FAIL = 'admin/auth/IDENTITY_LOGOUT_FAIL';
const IDENTITY_LOGOUT_SUCCESS = 'admin/auth/IDENTITY_LOGOUT_SUCCESS';

const SET_LAST_ACTIVITY = 'admin/auth/SET_LAST_ACTIVITY';

export {
  ADMIN_LOGIN,
  ADMIN_LOGIN_FAIL,
  ADMIN_LOGIN_SUCCESS,
  ADMIN_LOGOUT,
  ADMIN_LOGOUT_FAIL,
  ADMIN_LOGOUT_SUCCESS,
  ADMIN_PROPERTIES_INTERVAL_RESOURCE,
  CLEAR_IDENTITY_SESSION,
  GET_PUBLIC_KEY,
  GET_PUBLIC_KEY_SUCCESS,
  GET_PUBLIC_KEY_FAIL,
  IDENTITY_LOGIN,
  IDENTITY_LOGIN_FAIL,
  IDENTITY_LOGIN_SUCCESS,
  IDENTITY_LOGOUT,
  IDENTITY_LOGOUT_FAIL,
  IDENTITY_LOGOUT_SUCCESS,
  RESOURCE_ADMIN_PROPERTIES_INTERVAL,
  SET_LAST_ACTIVITY,
};

export type PollingTimeoutHandler = () => Promise<void>;

export type PublicKeyInfo = {|
  +modulusBase16: string,
  +exponent: string,
|};

export type Auth = {
  +adminSessionId: ?string,
  +identitySessionId: ?string,
  +username: ?string,
  +lastActivity: number,
  +identityEncryptedPassword: ?string,
  +publicKeyInfo: ?PublicKeyInfo,
};

type AdminLoginAction = {|
  type: 'admin/auth/ADMIN_LOGIN',
  payload: {| +username: string |},
|};

type AdminLoginFailAction = {|
  type: 'admin/auth/ADMIN_LOGIN_FAIL',
|};

type AdminLoginSuccessAction = {|
  type: 'admin/auth/ADMIN_LOGIN_SUCCESS',
  payload: {| +session: string |},
|};

type AdminLogoutAction = {|
  type: 'admin/auth/ADMIN_LOGOUT',
  payload: {| +session: string |},
|};

type AdminLogoutFailAction = {|
  type: 'admin/auth/ADMIN_LOGOUT_FAIL',
|};

type AdminLogoutSuccessAction = {|
  type: 'admin/auth/ADMIN_LOGOUT_SUCCESS',
|};

type ClearIdentitySessionAction = {|
  type: 'admin/CLEAR_IDENTITY_SESSION',
|};

type GetPublicKeyAction = {|
  type: 'admin/GET_PUBLIC_KEY',
|};

type GetPublicKeyFailAction = {|
  type: 'admin/GET_PUBLIC_KEY_FAIL',
|};

type GetPublicKeySuccessAction = {|
  type: 'admin/GET_PUBLIC_KEY_SUCCESS',
  payload: PublicKeyInfo,
|};

type IdentityLoginAction = {|
  type: 'admin/auth/IDENTITY_LOGIN',
  payload: {| +username: string, +encryptedPassword: string |},
|};

type IdentityLoginFailAction = {|
  type: 'admin/auth/IDENTITY_LOGIN_FAIL',
|};

type IdentityLoginSuccessAction = {|
  type: 'admin/auth/IDENTITY_LOGIN_SUCCESS',
  payload: {| +session: string |},
|};

type IdentityLogoutAction = {|
  type: 'admin/auth/IDENTITY_LOGOUT',
  payload: {| +session: string |},
|};

type IdentityLogoutFailAction = {|
  type: 'admin/auth/IDENTITY_LOGOUT_FAIL',
|};

type IdentityLogoutSuccessAction = {|
  type: 'admin/auth/IDENTITY_LOGOUT_SUCCESS',
|};

type SetAdminPropertiesPollIntervalAction = {|
  type: 'admin/auth/RESOURCE_ADMIN_PROPERTIES_INTERVAL',
  resource: 'ADMIN_PROPERTIES_INTERVAL_RESOURCE',
  payload: PollingTimeoutHandler,
|};

type SetLastActivityAction = {
  type: 'admin/auth/SET_LAST_ACTIVITY',
  payload: { lastActivity: number },
};

export type Action =
  | AdminLoginAction
  | AdminLoginFailAction
  | AdminLoginSuccessAction
  | AdminLogoutAction
  | AdminLogoutFailAction
  | AdminLogoutSuccessAction
  | ClearIdentitySessionAction
  | GetPublicKeyAction
  | GetPublicKeyFailAction
  | GetPublicKeySuccessAction
  | IdentityLoginAction
  | IdentityLoginFailAction
  | IdentityLoginSuccessAction
  | IdentityLogoutAction
  | IdentityLogoutFailAction
  | IdentityLogoutSuccessAction
  | SetAdminPropertiesPollIntervalAction
  | SetLastActivityAction;



// WEBPACK FOOTER //
// ./src/state/types/authTypes.js